export function scrollToWaitlist(): void {
  const el = document.getElementById('rejoindre');
  if (!el) return;
  const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  el.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
  const input = el.querySelector<HTMLInputElement>('input[type="tel"], input[name="phone"]');
  input?.focus({ preventScroll: true });
}
